module.exports = __webpack_public_path__ + "static/assets/8036e0e81c7eb86ba695c0a0a71bc775.svg";